module.exports = __webpack_public_path__ + "img/204-4e534d.png";